// extracted by css-extract-rspack-plugin
export default {"fileRendererViewport":"RichDiff-module__fileRendererViewport__bCfsBeG","fileRendererIframe":"RichDiff-module__fileRendererIframe__bL7zS1g"};